module.exports = __webpack_public_path__ + "4df3dd89d43f474e5a181c78c18da96a.pdf";